<script>
export default {
  name: "AdminList",
  props: [],
  data: () => ({
    appRoot: "",
  }),
  components: {},
  computed: {
    dataReport: {
      get() {
        return this.$store.getters.dataReport;
      },
    },
  },
  created() {
    // get questions actions store
    this.$store.dispatch("getQuestions").then(() => {
      this.questions = this.$store.getters.questions;
      this.appRoot = process.env.VUE_APP_ROOT;
    });
  },
};
</script>
<template>
  <div id="AdminList">
    <div class="result">Quantidade de registros : {{ dataReport.length }}</div>
    <div class="mx-auto overflow" v-if="dataReport.length">
      <div class="bg-white shadow-md rounded my-6">
        <table class="text-left w-full border-collapse">
          <!--Border collapse doesn't work on this site yet but it's available in newer tailwind versions -->
          <thead>
            <tr>
              <th
                class="
                  py-4
                  px-6
                  bg-grey-lightest
                  font-bold
                  uppercase
                  text-sm text-grey-dark
                  border-b border-grey-light
                "
              >
                Estado
              </th>
              <th
                class="
                  py-4
                  px-6
                  bg-grey-lightest
                  font-bold
                  uppercase
                  text-sm text-grey-dark
                  border-b border-grey-light
                "
              >
                Lead
              </th>
              <th
                class="
                  py-4
                  px-6
                  bg-grey-lightest
                  font-bold
                  uppercase
                  text-sm text-grey-dark
                  border-b border-grey-light
                "
              >
                Email
              </th>
              <th
                class="
                  py-4
                  px-6
                  bg-grey-lightest
                  font-bold
                  uppercase
                  text-sm text-grey-dark
                  border-b border-grey-light
                "
              >
                Telefone
              </th>
              <th
                class="
                  py-4
                  px-6
                  bg-grey-lightest
                  font-bold
                  uppercase
                  text-sm text-grey-dark
                  border-b border-grey-light
                "
              >
                Cargo
              </th>
              <th
                class="
                  py-4
                  px-6
                  bg-grey-lightest
                  font-bold
                  uppercase
                  text-sm text-grey-dark
                  border-b border-grey-light
                "
              >
                Empresa
              </th>
              <th
                class="
                  py-4
                  px-6
                  bg-grey-lightest
                  font-bold
                  uppercase
                  text-sm text-grey-dark
                  border-b border-grey-light
                "
              >
                Site Empresa
              </th>
              <th
                class="
                  py-4
                  px-6
                  bg-grey-lightest
                  font-bold
                  uppercase
                  text-sm text-grey-dark
                  border-b border-grey-light
                "
              >
                Tamanho Empresa
              </th>
              <th
                class="
                  py-4
                  px-6
                  bg-grey-lightest
                  font-bold
                  uppercase
                  text-sm text-grey-dark
                  border-b border-grey-light
                "
              >
                Data Criação
              </th>
              <th
                class="
                  py-4
                  px-6
                  bg-grey-lightest
                  font-bold
                  uppercase
                  text-sm text-grey-dark
                  border-b border-grey-light
                "
              >
                Pergunta
              </th>
              <th
                class="
                  py-4
                  px-6
                  bg-grey-lightest
                  font-bold
                  uppercase
                  text-sm text-grey-dark
                  border-b border-grey-light
                "
              >
                Resposta
              </th>
              <th
                class="
                  py-4
                  px-6
                  bg-grey-lightest
                  font-bold
                  uppercase
                  text-sm text-grey-dark
                  border-b border-grey-light
                "
              >
                Peso
              </th>
              <th
                class="
                  py-4
                  px-6
                  bg-grey-lightest
                  font-bold
                  uppercase
                  text-sm text-grey-dark
                  border-b border-grey-light
                "
              >
                Resultado
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="hover:bg-grey-lighter"
              v-for="(row, index) in dataReport"
              :key="index"
            >
              <td class="py-4 px-6 border-b border-grey-light">
                {{ row.answerId ? "Finalizado" : "Lead" }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ row.name }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ row.email }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ row.corporate_phone }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ row.position }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ row.company_name }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ row.company_website }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ row.company_size }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ row.createdAt }}
              </td>
              <td
                v-bind:title="row.question"
                class="py-4 px-6 border-b border-grey-light"
              >
                <div v-if="row.question" class="clamp-3">
                  {{ row.question }}
                </div>
                <div v-if="!row.question">-</div>
              </td>
              <td
                v-bind:title="row.answer"
                class="py-4 px-6 border-b border-grey-light"
              >
                <div v-if="row.answer" class="clamp-3">{{ row.answer }}</div>
                <div v-if="!row.question">-</div>
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                <div v-if="row.score" class="clamp-3">{{ row.score }}</div>
                <div v-if="!row.question">-</div>
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                <a
                  v-if="row.externalId"
                  target="_blank"
                  v-bind:href="appRoot + /result/ + row.externalId"
                >
                  {{ appRoot + /result/ + row.externalId }}
                </a>
                <div v-if="!row.question">-</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
